var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect, useCallback, useRef } from "react";
import moment from "moment";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useQuery } from "react-query";
import { createPublisherSchema, isEmptyAlternativeName, isEmptyGuarantor, } from "./validationUtils";
import { FormattedMessage, useIntl } from "react-intl";
import { Pane, Button, Row, Col, AccordionSet, Accordion, Checkbox, PaneFooter, MessageBanner, Spinner, ConfirmationModal, } from "@folio/stripes/components";
import { useHistory } from "react-router-dom";
import { useOkapiKy } from "@folio/stripes/core";
import { RecekTextField, RecekSelect, RecekSelection, RecekTextArea, RecekDatepicker, RecekAccordionLabel, } from "./inputs";
import { ErrorType } from "../types/ErrorType";
import { useRegistrationProtection } from "./useRegistrationProtection";
import { useAddressSuggest } from "./useAddressSuggest";
import { REGISTRATION_CAPTCHA_PATH, createPublisherRegistration, getResponseStatus, isCaptchaInvalidError, isTooManyRequestsError, } from "./publisherRegistrationApi";
import { AltchaWidget, } from "./Recek/altcha/AltchaWidget";
import { scrollToError } from "./scrollUtils";
import { formatFieldsForPublicationForm, formatFieldsForSelection, formatsOfPublicationForm, isMultipleWorkSpecFormatsError, missingRefiningFormat, } from "./workSpecificationUtils";
import { AuthorityAuthorRow } from "./AuthorityAuthorRow";
import { RegistrationContactNotice } from "./RegistrationContactNotice";
import { RegistrationPrivacyNotice } from "./RegistrationPrivacyNotice";
import { AUTHORITY_AUTHORS_PATH, AUTHORITY_AUTHOR_LIMIT, normalizeAuthors, personIdsLinkedElsewhere, unlinkedAuthor, } from "./authorityAuthorUtils";
var PUBLICATION_FORM_OPTIONS = [
    {
        value: "PRINT",
        labelId: "stripes-core.publishers.workSpec.select.label.publicationForm.print",
    },
    {
        value: "EBOOK",
        labelId: "stripes-core.publishers.workSpec.select.label.publicationForm.ebook",
    },
    {
        value: "DATA_CARRIER",
        labelId: "stripes-core.publishers.workSpec.select.label.publicationForm.dataCarrier",
    },
    {
        value: "AUDIOBOOK",
        labelId: "stripes-core.publishers.workSpec.select.label.publicationForm.audiobook",
    },
];
/** The one required refining select shown for each publication form, with its own label. */
var REFINING_SELECTS = {
    PRINT: {
        name: "workSpecification.publicationType.printedPublications",
        labelId: "stripes-core.publishers.workSpec.select.label.printedPublicationBinding",
        options: [
            {
                value: "SOFTCOVER",
                labelId: "stripes-core.publishers.workSpec.select.label.printedPublicationBinding.soft",
            },
            {
                value: "HARDCOVER",
                labelId: "stripes-core.publishers.workSpec.select.label.printedPublicationBinding.hard",
            },
        ],
    },
    EBOOK: {
        name: "workSpecification.eBookFormats",
        labelId: "stripes-core.publishers.workSpec.select.label.ebookFormats",
        options: [
            {
                value: "PDF",
                labelId: "stripes-core.publishers.workSpec.select.label.ebookFormats.pdf",
            },
            {
                value: "EPUB",
                labelId: "stripes-core.publishers.workSpec.select.label.ebookFormats.epub",
            },
            {
                value: "MOBI",
                labelId: "stripes-core.publishers.workSpec.select.label.ebookFormats.mobi",
            },
        ],
    },
    DATA_CARRIER: {
        name: "workSpecification.dataCarrierVersions",
        labelId: "stripes-core.publishers.workSpec.select.label.dataCarrierType",
        options: [
            {
                value: "CD_ROM",
                labelId: "stripes-core.publishers.workSpec.select.label.dataCarrierVersion.cd",
            },
            {
                value: "DVD_ROM",
                labelId: "stripes-core.publishers.workSpec.select.label.dataCarrierVersion.dvd",
            },
        ],
    },
    AUDIOBOOK: {
        name: "workSpecification.audioBookFormats",
        labelId: "stripes-core.publishers.workSpec.select.label.audioBookForm",
        options: [
            {
                value: "ON_CARRIER",
                labelId: "stripes-core.publishers.workSpec.select.label.audioBook.on",
            },
            {
                value: "WITHOUT_CARRIER",
                labelId: "stripes-core.publishers.workSpec.select.label.audioBook.off",
            },
        ],
    },
};
var REFINING_FIELD_PATHS = [
    "workSpecification.publicationType.printedPublications",
    "workSpecification.eBookFormats",
    "workSpecification.dataCarrierVersions",
    "workSpecification.audioBookFormats",
];
var YEAR_REGEX = /^\d{4}$/;
var MONTH_YEAR_REGEX = /^(0[1-9]|1[0-2])\.\d{4}$/;
var FULL_DATE_REGEX = /^(0[1-9]|[12]\d|3[01])\.(0[1-9]|1[0-2])\.\d{4}$/;
var isValidPartialDate = function (val) {
    if (YEAR_REGEX.test(val))
        return true;
    if (MONTH_YEAR_REGEX.test(val))
        return true;
    if (FULL_DATE_REGEX.test(val)) {
        var _a = val.split(".").map(Number), day = _a[0], month = _a[1], year = _a[2];
        var date = new Date(year, month - 1, day);
        return (date.getFullYear() === year &&
            date.getMonth() === month - 1 &&
            date.getDate() === day);
    }
    return false;
};
var getYearFromPartialDate = function (val) {
    if (YEAR_REGEX.test(val))
        return parseInt(val, 10);
    if (MONTH_YEAR_REGEX.test(val))
        return parseInt(val.split(".")[1], 10);
    if (FULL_DATE_REGEX.test(val))
        return parseInt(val.split(".")[2], 10);
    return null;
};
var MIN_PUBLICATION_YEAR = 1989;
var MAX_PUBLICATION_YEAR = 2100;
var FORM_VALID_TIME = 1000 * 5; // 5 seconds
var PublisherRegistration = function () {
    var _a, _b;
    var history = useHistory();
    var ky = useOkapiKy();
    var startTime = useRegistrationProtection().startTime;
    var captchaRef = useRef(null);
    // The solved captcha is single-use: read once per submit, reset after every failed submit.
    var captchaPayloadRef = useRef(null);
    var handleCaptchaPayload = useCallback(function (payload) {
        captchaPayloadRef.current = payload;
    }, []);
    var resetCaptcha = function () {
        var _a;
        captchaPayloadRef.current = null;
        (_a = captchaRef.current) === null || _a === void 0 ? void 0 : _a.reset();
    };
    var formatMessage = useIntl().formatMessage;
    var publisherSchema = createPublisherSchema(formatMessage);
    var lookupPublisherByCompanyNumber = function (ky, companyNumber) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ky.get("publishers/registration/".concat(companyNumber, "/lookup"), {
                        headers: {
                            "Content-Type": "application/json",
                            Pragma: "no-cache",
                            Expires: "0",
                        },
                    })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Unexpected error");
                    }
                    return [2 /*return*/, response.json()];
            }
        });
    }); };
    var checkDuplicateIco = function (companyNumber) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ky.get("publishers/registration/".concat(companyNumber, "/check-duplicity"), {
                            headers: {
                                "Content-Type": "application/json",
                                Pragma: "no-cache",
                                Expires: "0",
                            },
                        })];
                case 1:
                    response = _c.sent();
                    return [2 /*return*/, false];
                case 2:
                    error_1 = _c.sent();
                    if (((_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.status) === 404) {
                        return [2 /*return*/, false];
                    }
                    if (((_b = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _b === void 0 ? void 0 : _b.status) === 422) {
                        return [2 /*return*/, true];
                    }
                    setIcoError(isTooManyRequestsError(error_1)
                        ? formatMessage({ id: "stripes-core.errors.too.many.requests" })
                        : error_1.message);
                    throw error_1;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var defaultHeaders = function () {
        return {
            "Cache-Control": "no-cache, no-store, must-revalidate",
            Pragma: "no-cache",
            Expires: "0",
        };
    };
    /** Searches the NK authority authors offered to the registration author rows (open route, DB-804). */
    var searchAuthorityAuthors = useCallback(function (query) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ky
                    .get(AUTHORITY_AUTHORS_PATH, {
                    searchParams: { query: query, limit: AUTHORITY_AUTHOR_LIMIT },
                })
                    .json()];
        });
    }); }, [ky]);
    var fetchAddressCode = function (ky, addressCode) { return __awaiter(void 0, void 0, void 0, function () {
        var response, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ky.get("publisher-address/registration/".concat(addressCode), {
                        headers: {
                            "Cache-Control": "no-cache, no-store, must-revalidate",
                            Pragma: "no-cache",
                            Expires: "0",
                        },
                    })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    return [2 /*return*/, data];
            }
        });
    }); };
    var fetchRegions = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
        var response, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, kyInstance.get("regions/public", {
                        headers: defaultHeaders(),
                    })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Error: ".concat(response.statusText));
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    return [2 /*return*/, data.regions];
            }
        });
    }); };
    var _c = useState({
        general: true,
        address: true,
        contacts: true,
        alternativeNames: true,
        comments: true,
        guarantors: true,
        workSpecification: true,
        spam: true,
    }), accordionStatus = _c[0], setAccordionStatus = _c[1];
    var _d = useForm({
        resolver: zodResolver(publisherSchema),
        shouldFocusError: false,
        defaultValues: {
            registrationAgency: "",
            registrationIntent: "",
            companyNumber: "",
            name: "",
            nameSuffix: "",
            qualifier: "",
            legalForm: "LEGAL",
            taxNumber: "",
            birthDate: "",
            status: "REQUEST",
            mainAddress: {
                addressCode: "",
                street: "",
                postalCode: "",
                municipality: "",
                region: { id: "", name: "" },
            },
            mailingAddress: {
                addressCode: "",
                street: "",
                postalCode: "",
                municipality: "",
                region: { id: "", name: "" },
            },
            contacts: [],
            alternativeNames: [],
            internalComment: "",
            guarantors: [
                {
                    id: "",
                    firstName: "",
                    lastName: "",
                    email: "",
                    contacts: [],
                    user: {
                        sourceId: "",
                        firstName: "",
                        lastName: "",
                        email: "",
                        roles: [],
                    },
                },
            ],
            workSpecification: {
                title: "",
                subtitle: "",
                volumeNumber: "",
                partTitle: "",
                authors: [unlinkedAuthor()],
                publicationDate: "",
                editionNumber: "",
                coEditionWith: "",
                publicationForm: "",
                publicationType: {
                    printedPublications: [],
                },
                eBookFormats: [],
                otherFormats: [],
                dataCarrierVersions: [],
                audioBookFormats: [],
            },
            mainAddressPublishConsent: true,
            mailingAddressPublishConsent: true,
        },
        mode: "onBlur",
    }), handleSubmit = _d.handleSubmit, control = _d.control, setValue = _d.setValue, getValues = _d.getValues, watch = _d.watch, errors = _d.formState.errors, trigger = _d.trigger, setError = _d.setError, clearErrors = _d.clearErrors;
    var _e = useFieldArray({
        control: control,
        name: "contacts",
    }), contactFields = _e.fields, appendContact = _e.append, removeContactAtIndex = _e.remove;
    var _f = useFieldArray({
        control: control,
        name: "alternativeNames",
    }), alternativeNameFields = _f.fields, appendAlternativeName = _f.append, removeAlternativeNameAtIndex = _f.remove;
    var _g = useFieldArray({
        control: control,
        name: "guarantors",
    }), guarantorFields = _g.fields, appendGuarantor = _g.append, removeGuarantorAtIndex = _g.remove;
    var _h = useFieldArray({
        control: control,
        name: "workSpecification.authors",
    }), authorFields = _h.fields, appendAuthor = _h.append, removeAuthor = _h.remove;
    var watchedAuthors = watch("workSpecification.authors");
    var _j = useFieldArray({
        control: control,
        name: "workSpecification.otherFormats",
    }), otherFormatFields = _j.fields, appendOtherFormat = _j.append, removeOtherFormat = _j.remove, replaceOtherFormats = _j.replace;
    var selectedPublicationForm = watch("workSpecification.publicationForm") || "";
    /** Writes the format fields of the work specification; only one form ever carries a format. */
    var applyFormatFields = function (values) {
        var options = { shouldDirty: true };
        setValue("workSpecification.publicationForm", values.publicationForm, options);
        setValue("workSpecification.publicationType.printedPublications", values.publicationType.printedPublications, options);
        setValue("workSpecification.eBookFormats", values.eBookFormats, options);
        setValue("workSpecification.dataCarrierVersions", values.dataCarrierVersions, options);
        setValue("workSpecification.audioBookFormats", values.audioBookFormats, options);
    };
    var handlePublicationFormChange = function (value) {
        var values = formatFieldsForPublicationForm(getValues("workSpecification"), value);
        applyFormatFields(values);
        // the free-text "Jiný formát" rows belong to an e-book only
        if (value !== "EBOOK") {
            replaceOtherFormats([]);
        }
        clearErrors(__spreadArray(["workSpecification.publicationForm"], REFINING_FIELD_PATHS, true));
    };
    var handleRefiningFormatChange = function (value) {
        if (!selectedPublicationForm)
            return;
        applyFormatFields(formatFieldsForSelection(getValues("workSpecification"), selectedPublicationForm, value));
        if (value) {
            clearErrors(__spreadArray([], REFINING_FIELD_PATHS, true));
        }
    };
    var refiningFormatError = function (form) {
        var _a, _b, _c, _d, _e;
        var ws = errors.workSpecification;
        switch (form) {
            case "PRINT":
                return (_b = (_a = ws === null || ws === void 0 ? void 0 : ws.publicationType) === null || _a === void 0 ? void 0 : _a.printedPublications) === null || _b === void 0 ? void 0 : _b.message;
            case "EBOOK":
                return (_c = ws === null || ws === void 0 ? void 0 : ws.eBookFormats) === null || _c === void 0 ? void 0 : _c.message;
            case "DATA_CARRIER":
                return (_d = ws === null || ws === void 0 ? void 0 : ws.dataCarrierVersions) === null || _d === void 0 ? void 0 : _d.message;
            case "AUDIOBOOK":
                return (_e = ws === null || ws === void 0 ? void 0 : ws.audioBookFormats) === null || _e === void 0 ? void 0 : _e.message;
            default:
                return undefined;
        }
    };
    var legalFormValue = watch("legalForm");
    useEffect(function () {
        if (legalFormValue === "LEGAL") {
            setValue("birthDate", "", { shouldValidate: true });
        }
    }, [legalFormValue, setValue]);
    useEffect(function () {
        if (Object.keys(errors).length > 0) {
            scrollToError(errors);
        }
    }, [errors]);
    var _k = useState(false), showConfirmation = _k[0], setShowConfirmation = _k[1];
    var _l = useState(null), pendingData = _l[0], setPendingData = _l[1];
    var _m = useState(false), enableMainAddress = _m[0], setEnableMainAddress = _m[1];
    var _o = useState(false), enableMailingAddress = _o[0], setEnableMailingAddress = _o[1];
    var _p = useState("Je nejaka chyba"), errorMessage = _p[0], setErrorMessage = _p[1];
    var _q = useState(false), errorMessageShow = _q[0], setErrorMessageShow = _q[1];
    var _r = useState(false), showMailingAddress = _r[0], setShowMailingAddress = _r[1];
    var _s = useState(true), expandAll = _s[0], setExpandAll = _s[1];
    var _t = useState([]), regions = _t[0], setRegions = _t[1];
    var _u = useAddressSuggest(ky), addressData = _u.addresses, addressSuggestRateLimited = _u.rateLimited, handleAddressInput = _u.onFilter;
    var addressSuggestError = addressSuggestRateLimited
        ? formatMessage({ id: "stripes-core.error.addressSuggestTooManyRequests" })
        : undefined;
    var _v = useState(false), confirmOpen = _v[0], setConfirmOpen = _v[1];
    var _w = useState(""), confirmMessage = _w[0], setConfirmMessage = _w[1];
    var handleAddressSelection = function (selectedValue, type) { return __awaiter(void 0, void 0, void 0, function () {
        var addressDetails, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetchAddressCode(ky, selectedValue)];
                case 1:
                    addressDetails = _a.sent();
                    setValue("".concat(type, ".addressCode"), selectedValue, { shouldValidate: true });
                    setValue("".concat(type, ".street"), addressDetails.street, { shouldValidate: true });
                    setValue("".concat(type, ".postalCode"), addressDetails.postalCode, { shouldValidate: true });
                    setValue("".concat(type, ".municipality"), addressDetails.municipality, { shouldValidate: true });
                    setValue("".concat(type, ".region"), addressDetails.region || { id: "", name: "" }, { shouldValidate: true });
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    console.error("Error fetching ".concat(type, " details:"), error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        fetchRegions(ky)
            .then(function (regionsTmp) {
            setRegions(regionsTmp);
        })
            .catch(function (error) {
            console.error("Error fetching regions: ", error);
            setRegions([]);
        });
    }, []);
    var companyNumber = watch("companyNumber");
    useEffect(function () {
        if (legalFormValue !== "NATURAL" ||
            (companyNumber && companyNumber.trim() !== "")) {
            setValue("mainAddressPublishConsent", undefined);
            setValue("mailingAddressPublishConsent", undefined);
        }
    }, [legalFormValue, companyNumber, setValue]);
    var _x = useState(null), icoError = _x[0], setIcoError = _x[1];
    var _y = useQuery(["publisher", companyNumber], function () { return lookupPublisherByCompanyNumber(ky, companyNumber !== null && companyNumber !== void 0 ? companyNumber : ""); }, {
        enabled: false,
        retry: false,
        onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var errors, currentError, translatedError;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (isTooManyRequestsError(error)) {
                            setIcoError(formatMessage({ id: "stripes-core.error.aresTooManyRequests" }));
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.json().catch(function () { return undefined; }))];
                    case 1:
                        errors = _d.sent();
                        currentError = (_b = errors === null || errors === void 0 ? void 0 : errors.errors) === null || _b === void 0 ? void 0 : _b[0];
                        translatedError = (_c = currentError === null || currentError === void 0 ? void 0 : currentError.message) !== null && _c !== void 0 ? _c : "";
                        if ((currentError === null || currentError === void 0 ? void 0 : currentError.type) === ErrorType.INTERNAL &&
                            (currentError === null || currentError === void 0 ? void 0 : currentError.code) === "NOT_FOUND_ERROR") {
                            translatedError = formatMessage({ id: "stripes-core.error.aresDataNotFound" }, { ico: companyNumber });
                        }
                        else if ((currentError === null || currentError === void 0 ? void 0 : currentError.type) === ErrorType.INVALID_ICO_FORMAT) {
                            translatedError = formatMessage({
                                id: "stripes-core.error.invalidIcoFormat",
                            });
                        }
                        setIcoError(translatedError);
                        return [2 /*return*/];
                }
            });
        }); },
    }), isIcoFetching = _y.isFetching, refetchIco = _y.refetch;
    var handleIco = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, icoPublisher, isError, error_3;
        var _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    _h.trys.push([0, 4, , 5]);
                    if (!companyNumber || companyNumber.trim() === "") {
                        setIcoError(formatMessage({
                            id: "stripes-core.error.companyNumber.required",
                        }));
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, refetchIco()];
                case 1:
                    _a = _h.sent(), icoPublisher = _a.data, isError = _a.isError;
                    if (isError)
                        return [2 /*return*/];
                    setValue("name", (_b = icoPublisher === null || icoPublisher === void 0 ? void 0 : icoPublisher.name) !== null && _b !== void 0 ? _b : "", { shouldValidate: true });
                    setValue("legalForm", (_c = icoPublisher === null || icoPublisher === void 0 ? void 0 : icoPublisher.legalForm) !== null && _c !== void 0 ? _c : getValues("legalForm"), {
                        shouldValidate: true,
                    });
                    setValue("taxNumber", (_d = icoPublisher === null || icoPublisher === void 0 ? void 0 : icoPublisher.taxNumber) !== null && _d !== void 0 ? _d : getValues("taxNumber"), {
                        shouldValidate: true,
                    });
                    setValue("contacts", (_f = (_e = icoPublisher === null || icoPublisher === void 0 ? void 0 : icoPublisher.contacts) !== null && _e !== void 0 ? _e : getValues("contacts")) !== null && _f !== void 0 ? _f : [], {
                        shouldValidate: true,
                    });
                    if (!((_g = icoPublisher === null || icoPublisher === void 0 ? void 0 : icoPublisher.mainAddress) === null || _g === void 0 ? void 0 : _g.addressCode)) return [3 /*break*/, 3];
                    return [4 /*yield*/, handleAddressSelection(icoPublisher === null || icoPublisher === void 0 ? void 0 : icoPublisher.mainAddress.addressCode, "mainAddress")];
                case 2:
                    _h.sent();
                    _h.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    error_3 = _h.sent();
                    console.error("Error fetching Ares data:", error_3);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var expandAllSections = function () {
        setAccordionStatus({
            general: true,
            address: true,
            contacts: true,
            alternativeNames: true,
            comments: true,
            guarantors: true,
            workSpecification: true,
            spam: true,
        });
        setExpandAll(true);
    };
    var collapseAllSections = function () {
        setAccordionStatus({
            general: false,
            address: false,
            contacts: false,
            alternativeNames: false,
            comments: false,
            guarantors: false,
            workSpecification: false,
            spam: false,
        });
        setExpandAll(false);
    };
    var toggleExpandCollapseAll = function () {
        if (expandAll) {
            collapseAllSections();
        }
        else {
            expandAllSections();
        }
    };
    var checkBots = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var elapsed;
        return __generator(this, function (_a) {
            elapsed = Date.now() - startTime;
            if (elapsed < FORM_VALID_TIME) {
                setErrorMessage(formatMessage({
                    id: "stripes-core.registration.protection.time.error",
                }));
                setErrorMessageShow(true);
                return [2 /*return*/, false];
            }
            if (data.website) {
                return [2 /*return*/, false];
            }
            if (!captchaPayloadRef.current) {
                // the captcha lives in the anti-spam section: open it so the user sees what to do
                setAccordionStatus(function (current) { return (__assign(__assign({}, current), { spam: true })); });
                setErrorMessage(formatMessage({ id: "stripes-core.errors.captcha.required" }));
                setErrorMessageShow(true);
                return [2 /*return*/, false];
            }
            return [2 /*return*/, true];
        });
    }); };
    var transformWorkSpecification = function (workSpec) {
        var _a, _b, _c, _d, _e, _f, _g;
        var filteredOtherFormats = (_a = workSpec.otherFormats) === null || _a === void 0 ? void 0 : _a.filter(function (format) { var _a; return (_a = format === null || format === void 0 ? void 0 : format.format) === null || _a === void 0 ? void 0 : _a.trim(); });
        return __assign({ title: ((_b = workSpec.title) === null || _b === void 0 ? void 0 : _b.trim()) || "", subtitle: ((_c = workSpec.subtitle) === null || _c === void 0 ? void 0 : _c.trim()) || "", volumeNumber: ((_d = workSpec.volumeNumber) === null || _d === void 0 ? void 0 : _d.trim()) || "", partTitle: ((_e = workSpec.partTitle) === null || _e === void 0 ? void 0 : _e.trim()) || "", 
            // keeps the NK authority link (personId + ID AUT) of a picked author (DB-804)
            authors: normalizeAuthors(workSpec.authors), publicationDate: workSpec.publicationDate || "", editionNumber: ((_f = workSpec.editionNumber) === null || _f === void 0 ? void 0 : _f.trim()) || "", coEditionWith: ((_g = workSpec.coEditionWith) === null || _g === void 0 ? void 0 : _g.trim()) || "" }, formatFieldsForPublicationForm(__assign(__assign({}, workSpec), { otherFormats: filteredOtherFormats }), workSpec.publicationForm || ""));
    };
    var submitPublisher = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var isValid, transformedWorkSpec, registrationAgency, registrationIntent, publisherData, submissionData, error_4, status_1, _a;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, checkBots(data)];
                case 1:
                    isValid = _e.sent();
                    if (!isValid) {
                        return [2 /*return*/];
                    }
                    transformedWorkSpec = data.registrationIntent === "ONE_OFF" && data.workSpecification
                        ? transformWorkSpecification(data.workSpecification)
                        : undefined;
                    registrationAgency = data.registrationAgency, registrationIntent = data.registrationIntent, publisherData = __rest(data, ["registrationAgency", "registrationIntent"]);
                    submissionData = __assign(__assign({}, publisherData), { registrations: registrationAgency && registrationIntent
                            ? [{ registrationAgency: registrationAgency, registrationIntent: registrationIntent }]
                            : [], workSpecification: transformedWorkSpec, contacts: (_b = data === null || data === void 0 ? void 0 : data.contacts) === null || _b === void 0 ? void 0 : _b.filter(function (contact) { return contact.type !== "" || contact.value !== ""; }), alternativeNames: (_c = data === null || data === void 0 ? void 0 : data.alternativeNames) === null || _c === void 0 ? void 0 : _c.filter(function (alternativeName) { return !isEmptyAlternativeName(alternativeName); }), guarantors: ((_d = data === null || data === void 0 ? void 0 : data.guarantors) === null || _d === void 0 ? void 0 : _d.filter(function (guarantor) { return !isEmptyGuarantor(guarantor); }).map(function (guarantor) {
                            var _a;
                            return (__assign(__assign({}, guarantor), { contacts: ((_a = guarantor.contacts) === null || _a === void 0 ? void 0 : _a.filter(function (contact) { var _a, _b; return ((_a = contact.type) === null || _a === void 0 ? void 0 : _a.trim()) !== "" && ((_b = contact.value) === null || _b === void 0 ? void 0 : _b.trim()) !== ""; })) || [] }));
                        })) || [] });
                    _e.label = 2;
                case 2:
                    _e.trys.push([2, 4, , 12]);
                    return [4 /*yield*/, createPublisherRegistration(ky, submissionData, captchaPayloadRef.current)];
                case 3:
                    _e.sent();
                    history.goBack();
                    return [3 /*break*/, 12];
                case 4:
                    error_4 = _e.sent();
                    console.error("Chyba při vytváření nakladatele:", error_4);
                    // the server verified (and so consumed) the captcha before failing: a new one is needed
                    resetCaptcha();
                    status_1 = getResponseStatus(error_4);
                    return [4 /*yield*/, isCaptchaInvalidError(error_4)];
                case 5:
                    if (!_e.sent()) return [3 /*break*/, 6];
                    setErrorMessage(formatMessage({ id: "stripes-core.errors.captcha.invalid" }));
                    return [3 /*break*/, 11];
                case 6:
                    if (!isTooManyRequestsError(error_4)) return [3 /*break*/, 7];
                    setErrorMessage(formatMessage({ id: "stripes-core.errors.too.many.requests" }));
                    return [3 /*break*/, 11];
                case 7:
                    if (!(status_1 === 409)) return [3 /*break*/, 8];
                    setErrorMessage(formatMessage({
                        id: "stripes-core.error.companyNumberAlreadyExists",
                    }));
                    return [3 /*break*/, 11];
                case 8:
                    _a = status_1 === 422;
                    if (!_a) return [3 /*break*/, 10];
                    return [4 /*yield*/, isMultipleWorkSpecFormatsError(error_4)];
                case 9:
                    _a = (_e.sent());
                    _e.label = 10;
                case 10:
                    if (_a) {
                        setErrorMessage(formatMessage({
                            id: "stripes-core.error.workSpec.multipleFormats",
                        }));
                    }
                    else {
                        setErrorMessage("Do\u0161lo k chyb\u011B p\u0159i vytv\u00E1\u0159en\u00ED nakladatele: ".concat(error_4));
                    }
                    _e.label = 11;
                case 11:
                    setErrorMessageShow(true);
                    return [3 /*break*/, 12];
                case 12: return [2 /*return*/];
            }
        });
    }); };
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var duplicateExists, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setIcoError(null);
                    if (!(data.companyNumber && data.companyNumber.trim() !== "")) return [3 /*break*/, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, checkDuplicateIco(data.companyNumber)];
                case 2:
                    duplicateExists = _b.sent();
                    if (duplicateExists) {
                        setPendingData(data);
                        setShowConfirmation(true);
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    return [2 /*return*/];
                case 4: return [4 /*yield*/, submitPublisher(data)];
                case 5:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleConfirmPopup = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!pendingData)
                        return [2 /*return*/];
                    return [4 /*yield*/, submitPublisher(pendingData)];
                case 1:
                    _a.sent();
                    setShowConfirmation(false);
                    setPendingData(null);
                    return [2 /*return*/];
            }
        });
    }); };
    var validateWorkSpecification = function () {
        var registrationIntent = getValues("registrationIntent");
        if (registrationIntent !== "ONE_OFF") {
            return true;
        }
        var workSpec = getValues("workSpecification");
        var hasErrors = false;
        if (!(workSpec === null || workSpec === void 0 ? void 0 : workSpec.title) || workSpec.title.trim() === "") {
            setError("workSpecification.title", {
                type: "manual",
                message: formatMessage({
                    id: "stripes-core.publishers.validation.workSpec.title",
                }),
            });
            hasErrors = true;
        }
        if (!(workSpec === null || workSpec === void 0 ? void 0 : workSpec.publicationDate) || workSpec.publicationDate.trim() === "") {
            setError("workSpecification.publicationDate", {
                type: "manual",
                message: formatMessage({
                    id: "stripes-core.publishers.validation.workSpec.publicationDate",
                }),
            });
            hasErrors = true;
        }
        else if (!isValidPartialDate(workSpec.publicationDate)) {
            setError("workSpecification.publicationDate", {
                type: "manual",
                message: formatMessage({
                    id: "stripes-core.publishers.validation.workSpec.publicationDate.format",
                }),
            });
            hasErrors = true;
        }
        else {
            var year = getYearFromPartialDate(workSpec.publicationDate);
            if (year !== null && year < MIN_PUBLICATION_YEAR) {
                setError("workSpecification.publicationDate", {
                    type: "manual",
                    message: formatMessage({
                        id: "stripes-core.publishers.validation.workSpec.publicationDate.min",
                    }),
                });
                hasErrors = true;
            }
            else if (year !== null && year > MAX_PUBLICATION_YEAR) {
                setError("workSpecification.publicationDate", {
                    type: "manual",
                    message: formatMessage({
                        id: "stripes-core.publishers.validation.workSpec.publicationDate.max",
                    }),
                });
                hasErrors = true;
            }
        }
        var missingFormat = missingRefiningFormat(workSpec);
        if (missingFormat) {
            setError(missingFormat.fieldPath, {
                type: "manual",
                message: formatMessage({ id: missingFormat.messageId }),
            });
            hasErrors = true;
        }
        if (!(workSpec === null || workSpec === void 0 ? void 0 : workSpec.editionNumber) || workSpec.editionNumber.trim() === "") {
            setError("workSpecification.editionNumber", {
                type: "manual",
                message: formatMessage({
                    id: "stripes-core.publishers.validation.workSpec.editionNumber",
                }),
            });
            hasErrors = true;
        }
        if (!(workSpec === null || workSpec === void 0 ? void 0 : workSpec.publicationForm) || workSpec.publicationForm.trim() === "") {
            setError("workSpecification.publicationForm", {
                type: "manual",
                message: formatMessage({
                    id: "stripes-core.publishers.validation.workSpec.publicationForm",
                }),
            });
            hasErrors = true;
        }
        return !hasErrors;
    };
    var handleFormSubmit = function (e) {
        e.preventDefault();
        handleSubmit(function (data) { return __awaiter(void 0, void 0, void 0, function () {
            var workSpecValid;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        workSpecValid = validateWorkSpecification();
                        if (!workSpecValid) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, onSubmit(data)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }, function (zodErrors) {
            setTimeout(function () {
                validateWorkSpecification();
            }, 0);
        })(e);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("form", { onSubmit: handleFormSubmit, noValidate: true },
            React.createElement("div", { style: { display: "flex", height: "97.5vh" } },
                React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                        id: "stripes-core.publishers.register.pane.title",
                    }), footer: React.createElement(PaneFooter, { renderStart: React.createElement(Button, { buttonStyle: "primary", type: "submit" },
                            React.createElement(FormattedMessage, { id: "stripes-core.button.save" })), renderEnd: React.createElement(Button, { buttonStyle: "default", onClick: function () { return history.goBack(); } },
                            React.createElement(FormattedMessage, { id: "stripes-core.button.cancel" })) }) },
                    React.createElement(Row, null,
                        React.createElement(Col, { xs: 12, style: {
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                justifyContent: "flex-end",
                                gap: "0.5rem 1rem",
                                marginBottom: "1rem",
                            } },
                            React.createElement("div", { style: { flex: "1 1 20rem", minWidth: 0 } },
                                React.createElement(RegistrationContactNotice, null)),
                            React.createElement(Button, { onClick: toggleExpandCollapseAll, buttonStyle: "default", marginBottom0: true, style: { marginLeft: "auto" } }, expandAll ? (React.createElement(FormattedMessage, { id: "stripes-core.button.collapse" })) : (React.createElement(FormattedMessage, { id: "stripes-core.button.expand" }))))),
                    React.createElement(Row, null,
                        React.createElement(Col, { xs: 12 },
                            React.createElement(RegistrationPrivacyNotice, null))),
                    React.createElement(AccordionSet, null,
                        React.createElement(MessageBanner, { autoFocusDismissButton: true, dismissible: true, onExited: function () { return setErrorMessageShow(false); }, show: errorMessageShow, type: "error" }, errorMessage),
                        React.createElement(Accordion, { label: React.createElement(RecekAccordionLabel, { labelId: "stripes-core.publishers.accordion.label.general" }), open: accordionStatus.general, onToggle: function () {
                                return setAccordionStatus(__assign(__assign({}, accordionStatus), { general: !accordionStatus.general }));
                            } },
                            React.createElement(Row, { style: { display: "none" } },
                                React.createElement(Col, { xs: 12 },
                                    React.createElement(Controller, { control: control, name: "website", render: function (_a) {
                                            var _b;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({ labelId: "stripes-core.publishers.general.field.label.website" }, field, { required: true, error: (_b = errors.name) === null || _b === void 0 ? void 0 : _b.message })));
                                        } }))),
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "registrationAgency", render: function (_a) {
                                            var _b;
                                            var field = _a.field;
                                            return (React.createElement(RecekSelect, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.label.select.registration.agency", required: true, error: (_b = errors.registrationAgency) === null || _b === void 0 ? void 0 : _b.message, dataOptions: [
                                                    {
                                                        value: "",
                                                        label: formatMessage({
                                                            id: "stripes-core.publishers.label.registration.agency.default",
                                                        }),
                                                    },
                                                    {
                                                        value: "ISBN",
                                                        label: formatMessage({
                                                            id: "stripes-core.publishers.label.registration.agency.ISBN",
                                                        }),
                                                    },
                                                    {
                                                        value: "ISMN",
                                                        label: formatMessage({
                                                            id: "stripes-core.publishers.label.registration.agency.ISMN",
                                                        }),
                                                    },
                                                ] })));
                                        } })),
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "registrationIntent", render: function (_a) {
                                            var _b;
                                            var field = _a.field;
                                            return (React.createElement(RecekSelect, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.label.select.registration.intent", required: true, error: (_b = errors.registrationIntent) === null || _b === void 0 ? void 0 : _b.message, dataOptions: [
                                                    {
                                                        value: "",
                                                        label: formatMessage({
                                                            id: "stripes-core.publishers.label.registration.intent.default",
                                                        }),
                                                    },
                                                    {
                                                        value: "CONTINUOUS",
                                                        label: formatMessage({
                                                            id: "stripes-core.publishers.label.registration.intent.CONTINUOUS",
                                                        }),
                                                    },
                                                    {
                                                        value: "ONE_OFF",
                                                        label: formatMessage({
                                                            id: "stripes-core.publishers.label.registration.intent.ONE_OFF",
                                                        }),
                                                    },
                                                ] })));
                                        } })),
                                React.createElement(Col, { xs: 6, style: {
                                        display: "flex",
                                        alignItems: Boolean((_a = errors.companyNumber) === null || _a === void 0 ? void 0 : _a.message) || icoError
                                            ? "center"
                                            : "flex-end",
                                    } },
                                    React.createElement(Controller, { control: control, name: "companyNumber", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(React.Fragment, null,
                                                React.createElement(RecekTextField, __assign({ labelId: "stripes-core.publishers.general.field.label.companyNumber", required: true }, field, { autoComplete: "off", onBlur: function () {
                                                        field.onBlur();
                                                        trigger([
                                                            "companyNumber",
                                                            "taxNumber",
                                                            "birthDate",
                                                        ]);
                                                    }, error: (_c = (_b = errors.companyNumber) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : icoError, onChange: function (e) {
                                                        field.onChange(e);
                                                        setIcoError(null);
                                                    } })),
                                                React.createElement(Button, { buttonStyle: "primary", onClick: handleIco, disabled: isIcoFetching, style: {
                                                        marginLeft: "16px",
                                                        marginBottom: "1rem",
                                                    } }, isIcoFetching ? (React.createElement(Spinner, null)) : (React.createElement(FormattedMessage, { id: "stripes-core.publishers.general.button.companyNumber" })))));
                                        } })),
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "legalForm", render: function (_a) {
                                            var field = _a.field;
                                            return (React.createElement(RecekSelect, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.general.select.label.legalForm", onChange: function (e) {
                                                    field.onChange(e);
                                                    trigger([
                                                        "companyNumber",
                                                        "taxNumber",
                                                        "birthDate",
                                                    ]);
                                                }, dataOptions: [
                                                    {
                                                        value: "LEGAL",
                                                        label: formatMessage({
                                                            id: "stripes-core.publishers.general.select.label.legal",
                                                        }),
                                                    },
                                                    {
                                                        value: "NATURAL",
                                                        label: formatMessage({
                                                            id: "stripes-core.publishers.general.select.label.natural",
                                                        }),
                                                    },
                                                ] })));
                                        } }))),
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "name", render: function (_a) {
                                            var _b;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({ labelId: legalFormValue === "LEGAL"
                                                    ? "stripes-core.publishers.general.field.label.name.legal"
                                                    : "stripes-core.publishers.general.field.label.name.natural" }, field, { autoComplete: "off", required: true, error: (_b = errors.name) === null || _b === void 0 ? void 0 : _b.message })));
                                        } })),
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "nameSuffix", render: function (_a) {
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({ labelId: "stripes-core.publishers.general.field.label.nameSuffix" }, field, { autoComplete: "off" })));
                                        } }))),
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "taxNumber", render: function (_a) {
                                            var _b;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({ labelId: "stripes-core.publishers.general.field.label.taxNumber" }, field, { autoComplete: "off", required: true, error: (_b = errors.taxNumber) === null || _b === void 0 ? void 0 : _b.message, onBlur: function () {
                                                    field.onBlur();
                                                    trigger([
                                                        "companyNumber",
                                                        "taxNumber",
                                                        "birthDate",
                                                    ]);
                                                } })));
                                        } })),
                                legalFormValue === "NATURAL" && (React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "birthDate", render: function (_a) {
                                            var _b;
                                            var field = _a.field;
                                            return (React.createElement(RecekDatepicker, __assign({ labelId: "stripes-core.publishers.general.datePicker.label.birthDate" }, field, { autoComplete: "off", error: (_b = errors.birthDate) === null || _b === void 0 ? void 0 : _b.message, backendDateStandard: "YYYY-MM-DD", dateFormat: "DD/MM/YYYY", placeholder: "DD/MM/RRRR", exclude: function (day) {
                                                    return day.isBefore(moment("1900-01-01", "YYYY-MM-DD")) || day.isAfter(moment());
                                                }, onBlur: function () {
                                                    field.onBlur();
                                                    trigger([
                                                        "companyNumber",
                                                        "taxNumber",
                                                        "birthDate",
                                                    ]);
                                                } })));
                                        } }))))),
                        React.createElement(Accordion, { label: React.createElement(RecekAccordionLabel, { labelId: "stripes-core.publishers.accordion.label.address" }), open: accordionStatus.address, onToggle: function () {
                                return setAccordionStatus(__assign(__assign({}, accordionStatus), { address: !accordionStatus.address }));
                            } },
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "mainAddress.addressCode", render: function (_a) {
                                            var field = _a.field;
                                            return (React.createElement(RecekSelection, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.mainAddress.selection.label.addressCode", asyncFilter: true, onFilter: handleAddressInput, error: addressSuggestError, dataOptions: addressData.map(function (address) { return ({
                                                    value: address.addressCode,
                                                    label: address.address,
                                                }); }), onChange: function (selectedValue) {
                                                    field.onChange(selectedValue);
                                                    handleAddressSelection(selectedValue, "mainAddress");
                                                } })));
                                        } })),
                                React.createElement(Checkbox, { label: formatMessage({
                                        id: "ui-br-publishers.publishers.mainAddress.checkbox.label.address",
                                    }), checked: enableMainAddress, onChange: function () {
                                        setEnableMainAddress(!enableMainAddress);
                                        if (!enableMainAddress) {
                                            setValue("mainAddress.addressCode", "");
                                            setValue("mainAddress.street", "");
                                            setValue("mainAddress.postalCode", "");
                                            setValue("mainAddress.municipality", "");
                                            setValue("mainAddress.region", { id: "", name: "" });
                                        }
                                    } }),
                                React.createElement(Col, { xs: 6 }, legalFormValue === "NATURAL" &&
                                    (!companyNumber || companyNumber.trim() === "") && (React.createElement(Controller, { control: control, name: "mainAddressPublishConsent", render: function (_a) {
                                        var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value, ref = _b.ref, name = _b.name;
                                        return (React.createElement(Checkbox, { label: formatMessage({
                                                id: "stripes-core.publishers.mainAddress.checkbox.label.addressPublishConsent",
                                            }), checked: value !== null && value !== void 0 ? value : false, onChange: function (e) { return onChange(e.target.checked); }, onBlur: onBlur, inputRef: ref, name: name }));
                                    } }))),
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "mainAddress.region.id", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(RecekSelect, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.mainAddress.select.label.region", required: true, error: (_c = (_b = errors.mainAddress) === null || _b === void 0 ? void 0 : _b.region) === null || _c === void 0 ? void 0 : _c.message, disabled: !enableMainAddress, dataOptions: __spreadArray([
                                                    {
                                                        value: "",
                                                        label: formatMessage({
                                                            id: "stripes-core.publishers.mainAddress.select.label.default",
                                                        }),
                                                    }
                                                ], regions.map(function (region) { return ({
                                                    value: region.id,
                                                    label: region.name,
                                                }); }), true), onChange: function (e) {
                                                    var selectedRegion = regions.find(function (region) { return region.id === e.target.value; });
                                                    setValue("mainAddress.region", selectedRegion || { id: "", name: "" });
                                                } })));
                                        } })),
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "mainAddress.street", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.mainAddress.field.label.street", error: (_c = (_b = errors.mainAddress) === null || _b === void 0 ? void 0 : _b.street) === null || _c === void 0 ? void 0 : _c.message, disabled: !enableMainAddress })));
                                        } })),
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "mainAddress.postalCode", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.mainAddress.field.label.postalCode", error: (_c = (_b = errors.mainAddress) === null || _b === void 0 ? void 0 : _b.postalCode) === null || _c === void 0 ? void 0 : _c.message, disabled: !enableMainAddress })));
                                        } })),
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "mainAddress.municipality", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.mainAddress.field.label.municipality", error: (_c = (_b = errors.mainAddress) === null || _b === void 0 ? void 0 : _b.municipality) === null || _c === void 0 ? void 0 : _c.message, disabled: !enableMainAddress })));
                                        } }))),
                            React.createElement(Checkbox, { label: formatMessage({
                                    id: "stripes-core.publishers.mailingAddress.checkbox.label.show",
                                }), checked: showMailingAddress, onChange: function () {
                                    setShowMailingAddress(!showMailingAddress);
                                    if (showMailingAddress) {
                                        setValue("mailingAddress.addressCode", "");
                                        setValue("mailingAddress.street", "");
                                        setValue("mailingAddress.postalCode", "");
                                        setValue("mailingAddress.municipality", "");
                                        setValue("mailingAddress.region", { id: "", name: "" });
                                        setValue("mailingAddressPublishConsent", undefined);
                                        setEnableMailingAddress(false);
                                    }
                                } }),
                            showMailingAddress && (React.createElement(React.Fragment, null,
                                React.createElement(Row, null,
                                    React.createElement(Col, { xs: 6 },
                                        React.createElement(Controller, { control: control, name: "mailingAddress.addressCode", render: function (_a) {
                                                var field = _a.field;
                                                return (React.createElement(RecekSelection, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.mailingAddress.selection.label.addressCode", asyncFilter: true, onFilter: handleAddressInput, error: addressSuggestError, dataOptions: addressData.map(function (address) { return ({
                                                        value: address.addressCode,
                                                        label: address.address,
                                                    }); }), onChange: function (selectedValue) {
                                                        field.onChange(selectedValue);
                                                        handleAddressSelection(selectedValue, "mailingAddress");
                                                    } })));
                                            } })),
                                    React.createElement(Col, { xs: 6 },
                                        legalFormValue === "NATURAL" &&
                                            (!companyNumber || companyNumber.trim() === "") && (React.createElement(Controller, { control: control, name: "mailingAddressPublishConsent", render: function (_a) {
                                                var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value, ref = _b.ref, name = _b.name;
                                                return (React.createElement(Checkbox, { label: formatMessage({
                                                        id: "stripes-core.publishers.mainAddress.checkbox.label.addressPublishConsent",
                                                    }), checked: value !== null && value !== void 0 ? value : false, onChange: function (e) { return onChange(e.target.checked); }, onBlur: onBlur, inputRef: ref, name: name }));
                                            } })),
                                        React.createElement(Checkbox, { label: formatMessage({
                                                id: "stripes-core.publishers.mailingAddress.checkbox.label.address",
                                            }), checked: enableMailingAddress, onChange: function () {
                                                setEnableMailingAddress(!enableMailingAddress);
                                                if (!enableMailingAddress) {
                                                    setValue("mailingAddress.addressCode", "");
                                                    setValue("mailingAddress.street", "");
                                                    setValue("mailingAddress.postalCode", "");
                                                    setValue("mailingAddress.municipality", "");
                                                    setValue("mailingAddress.region", {
                                                        id: "",
                                                        name: "",
                                                    });
                                                }
                                            } })),
                                    React.createElement(Col, { xs: 6 },
                                        React.createElement(Controller, { control: control, name: "mailingAddress.region.id", render: function (_a) {
                                                var _b, _c;
                                                var field = _a.field;
                                                return (React.createElement(RecekSelect, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.mailingAddress.select.label.region", error: (_c = (_b = errors.mailingAddress) === null || _b === void 0 ? void 0 : _b.region) === null || _c === void 0 ? void 0 : _c.message, disabled: !enableMailingAddress, dataOptions: __spreadArray([
                                                        {
                                                            value: "",
                                                            label: formatMessage({
                                                                id: "stripes-core.publishers.mailingAddress.select.label.default",
                                                            }),
                                                        }
                                                    ], regions.map(function (region) { return ({
                                                        value: region.id,
                                                        label: region.name,
                                                    }); }), true), onChange: function (e) {
                                                        var selectedRegion = regions.find(function (region) { return region.id === e.target.value; });
                                                        setValue("mailingAddress.region", selectedRegion || { id: "", name: "" });
                                                    } })));
                                            } })),
                                    React.createElement(Col, { xs: 6 },
                                        React.createElement(Controller, { control: control, name: "mailingAddress.street", render: function (_a) {
                                                var _b, _c;
                                                var field = _a.field;
                                                return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.mailingAddress.field.label.street", error: (_c = (_b = errors.mailingAddress) === null || _b === void 0 ? void 0 : _b.street) === null || _c === void 0 ? void 0 : _c.message, disabled: !enableMailingAddress })));
                                            } })),
                                    React.createElement(Col, { xs: 6 },
                                        React.createElement(Controller, { control: control, name: "mailingAddress.postalCode", render: function (_a) {
                                                var _b, _c;
                                                var field = _a.field;
                                                return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.mailingAddress.field.label.postalCode", error: (_c = (_b = errors.mailingAddress) === null || _b === void 0 ? void 0 : _b.postalCode) === null || _c === void 0 ? void 0 : _c.message, disabled: !enableMailingAddress })));
                                            } })),
                                    React.createElement(Col, { xs: 6 },
                                        React.createElement(Controller, { control: control, name: "mailingAddress.municipality", render: function (_a) {
                                                var _b, _c;
                                                var field = _a.field;
                                                return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.mailingAddress.field.label.municipality", error: (_c = (_b = errors.mailingAddress) === null || _b === void 0 ? void 0 : _b.municipality) === null || _c === void 0 ? void 0 : _c.message, disabled: !enableMailingAddress })));
                                            } })))))),
                        React.createElement(Accordion, { label: React.createElement(RecekAccordionLabel, { labelId: "stripes-core.publishers.accordion.label.contacts" }), open: accordionStatus.contacts, onToggle: function () {
                                return setAccordionStatus(__assign(__assign({}, accordionStatus), { contacts: !accordionStatus.contacts }));
                            } },
                            contactFields.map(function (field, index) { return (React.createElement(Row, { key: field.id },
                                React.createElement(Col, { xs: 4 },
                                    React.createElement(Controller, { control: control, name: "contacts.".concat(index, ".type"), render: function (_a) {
                                            var _b, _c, _d, _e, _f;
                                            var field = _a.field;
                                            return (React.createElement(RecekSelect, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.contacts.select.label.type", error: typeof ((_c = (_b = errors.contacts) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.type) === "object"
                                                    ? (_f = (_e = (_d = errors.contacts) === null || _d === void 0 ? void 0 : _d[index]) === null || _e === void 0 ? void 0 : _e.type) === null || _f === void 0 ? void 0 : _f.message
                                                    : undefined, dataOptions: [
                                                    {
                                                        value: "",
                                                        label: formatMessage({
                                                            id: "stripes-core.publishers.contacts.select.label.default",
                                                        }),
                                                    },
                                                    {
                                                        value: "EMAIL",
                                                        label: formatMessage({
                                                            id: "stripes-core.publishers.contacts.select.label.email",
                                                        }),
                                                    },
                                                    {
                                                        value: "WEB",
                                                        label: formatMessage({
                                                            id: "stripes-core.publishers.contacts.select.label.web",
                                                        }),
                                                    },
                                                    {
                                                        value: "PHONE",
                                                        label: formatMessage({
                                                            id: "stripes-core.publishers.contacts.select.label.phone",
                                                        }),
                                                    },
                                                    {
                                                        value: "DATA_BOX",
                                                        label: formatMessage({
                                                            id: "stripes-core.publishers.contacts.select.label.dataBox",
                                                        }),
                                                    },
                                                ] })));
                                        } })),
                                React.createElement(Col, { xs: 4 },
                                    React.createElement(Controller, { control: control, name: "contacts.".concat(index, ".value"), render: function (_a) {
                                            var _b, _c, _d;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.contacts.field.label.contact", error: (_d = (_c = (_b = errors.contacts) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.message })));
                                        } })),
                                React.createElement(Col, { xs: 4 },
                                    React.createElement(Controller, { control: control, name: "contacts.".concat(index, ".info"), render: function (_a) {
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.contacts.field.label.info" })));
                                        } })),
                                React.createElement(Col, { xs: 2 },
                                    React.createElement(Button, { buttonStyle: "danger", onClick: function () { return removeContactAtIndex(index); }, style: { marginTop: "25px" } },
                                        React.createElement(FormattedMessage, { id: "stripes-core.publishers.contacts.button.delete" }))))); }),
                            React.createElement(Button, { onClick: function () {
                                    return appendContact({
                                        type: "",
                                        value: "",
                                    }, { shouldFocus: false });
                                } },
                                React.createElement(FormattedMessage, { id: "stripes-core.publishers.contacts.button.add" }))),
                        React.createElement(Accordion, { label: React.createElement(RecekAccordionLabel, { labelId: "stripes-core.publishers.accordion.label.alternativeNames" }), open: accordionStatus.alternativeNames, onToggle: function () {
                                return setAccordionStatus(__assign(__assign({}, accordionStatus), { alternativeNames: !accordionStatus.alternativeNames }));
                            } },
                            alternativeNameFields.map(function (field, index) { return (React.createElement(Row, { key: field.id },
                                React.createElement(Col, { xs: 4 },
                                    React.createElement(Controller, { control: control, name: "alternativeNames.".concat(index, ".name"), defaultValue: field.name, render: function (_a) {
                                            var _b, _c, _d;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.alternativeNames.field.label.name", required: true, error: (_d = (_c = (_b = errors.alternativeNames) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.name) === null || _d === void 0 ? void 0 : _d.message })));
                                        } })),
                                React.createElement(Col, { xs: 4 },
                                    React.createElement(Controller, { control: control, name: "alternativeNames.".concat(index, ".nameSuffix"), defaultValue: field.nameSuffix, render: function (_a) {
                                            var _b, _c, _d;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.alternativeNames.field.label.nameSuffix", error: (_d = (_c = (_b = errors.alternativeNames) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.nameSuffix) === null || _d === void 0 ? void 0 : _d.message })));
                                        } })),
                                React.createElement(Col, { xs: 4 },
                                    React.createElement(Controller, { control: control, name: "alternativeNames.".concat(index, ".qualifier"), defaultValue: field.qualifier, render: function (_a) {
                                            var _b, _c, _d;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.alternativeNames.field.label.qualifier", error: (_d = (_c = (_b = errors.alternativeNames) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.qualifier) === null || _d === void 0 ? void 0 : _d.message })));
                                        } })),
                                React.createElement(Col, { xs: 4 },
                                    React.createElement(Controller, { control: control, name: "alternativeNames.".concat(index, ".type"), defaultValue: field.type, render: function (_a) {
                                            var field = _a.field;
                                            return (React.createElement(RecekSelect, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.alternativeNames.select.label.type", dataOptions: [
                                                    {
                                                        value: "PREVIOUS",
                                                        label: formatMessage({
                                                            id: "stripes-core.publishers.alternativeNames.select.label.previous",
                                                        }),
                                                    },
                                                    {
                                                        value: "IMPRINT",
                                                        label: formatMessage({
                                                            id: "stripes-core.publishers.alternativeNames.select.label.imprint",
                                                        }),
                                                    },
                                                    {
                                                        value: "ABBREVIATION",
                                                        label: formatMessage({
                                                            id: "stripes-core.publishers.alternativeNames.select.label.abbrevation",
                                                        }),
                                                    },
                                                    {
                                                        value: "ORGANIZATION_UNIT",
                                                        label: formatMessage({
                                                            id: "stripes-core.publishers.alternativeNames.select.label.organizationUnit",
                                                        }),
                                                    },
                                                    {
                                                        value: "FOREIGN_LANGUAGE",
                                                        label: formatMessage({
                                                            id: "stripes-core.publishers.alternativeNames.select.label.foreignLanguage",
                                                        }),
                                                    },
                                                ] })));
                                        } })),
                                React.createElement(Col, { xs: 2 },
                                    React.createElement(Controller, { control: control, name: "alternativeNames.".concat(index, ".nonPublic"), defaultValue: field.nonPublic, render: function (_a) {
                                            var field = _a.field;
                                            return (React.createElement(Checkbox, { checked: field.value, onChange: function (e) { return field.onChange(e.target.checked); }, label: formatMessage({
                                                    id: "stripes-core.publishers.alternativeNames.checkbox.label.nonPublic",
                                                }) }));
                                        } })),
                                React.createElement(Col, { xs: 12 },
                                    React.createElement(Button, { buttonStyle: "danger", onClick: function () { return removeAlternativeNameAtIndex(index); }, style: { marginTop: "10px" } },
                                        React.createElement(FormattedMessage, { id: "stripes-core.publishers.alternativeNames.button.delete" }))))); }),
                            React.createElement(Button, { onClick: function () {
                                    return appendAlternativeName({
                                        name: "",
                                        nameSuffix: "",
                                        qualifier: "",
                                        type: undefined,
                                        nonPublic: false,
                                    }, { shouldFocus: false });
                                } },
                                React.createElement(FormattedMessage, { id: "stripes-core.publishers.alternativeNames.button.add" }))),
                        React.createElement(Accordion, { label: React.createElement(RecekAccordionLabel, { labelId: "stripes-core.publishers.accordion.label.guarantors" }), id: "guarantors", open: accordionStatus.guarantors, onToggle: function () {
                                return setAccordionStatus(__assign(__assign({}, accordionStatus), { guarantors: !accordionStatus.guarantors }));
                            } },
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 12 },
                                    guarantorFields.map(function (guarantor, index) {
                                        var _a;
                                        return (React.createElement("div", { key: guarantor.id },
                                            React.createElement(Row, null,
                                                React.createElement(Col, { xs: 12, md: 4 },
                                                    React.createElement(Controller, { control: control, name: "guarantors.".concat(index, ".titlesBefore"), render: function (_a) {
                                                            var field = _a.field;
                                                            return (React.createElement(RecekTextField, __assign({ labelId: "stripes-core.publishers.guarantors.field.label.titlesBefore" }, field, { autoComplete: "off" })));
                                                        } })),
                                                React.createElement(Col, { xs: 12, md: 4 },
                                                    React.createElement(Controller, { control: control, name: "guarantors.".concat(index, ".firstName"), render: function (_a) {
                                                            var _b, _c, _d;
                                                            var field = _a.field;
                                                            return (React.createElement(RecekTextField, __assign({ labelId: "stripes-core.publishers.guarantors.field.label.firstName" }, field, { autoComplete: "off", required: true, error: (_d = (_c = (_b = errors.guarantors) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.firstName) === null || _d === void 0 ? void 0 : _d.message })));
                                                        } })),
                                                React.createElement(Col, { xs: 12, md: 4 },
                                                    React.createElement(Controller, { control: control, name: "guarantors.".concat(index, ".lastName"), render: function (_a) {
                                                            var _b, _c, _d;
                                                            var field = _a.field;
                                                            return (React.createElement(RecekTextField, __assign({ labelId: "stripes-core.publishers.guarantors.field.label.lastName" }, field, { autoComplete: "off", required: true, error: (_d = (_c = (_b = errors.guarantors) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.lastName) === null || _d === void 0 ? void 0 : _d.message })));
                                                        } })),
                                                React.createElement(Col, { xs: 12, md: 4 },
                                                    React.createElement(Controller, { control: control, name: "guarantors.".concat(index, ".titlesAfter"), render: function (_a) {
                                                            var field = _a.field;
                                                            return (React.createElement(RecekTextField, __assign({ labelId: "stripes-core.publishers.guarantors.field.label.titlesAfter" }, field, { autoComplete: "off" })));
                                                        } })),
                                                React.createElement(Col, { xs: 12, md: 4 },
                                                    React.createElement(Controller, { control: control, name: "guarantors.".concat(index, ".email"), render: function (_a) {
                                                            var _b, _c, _d;
                                                            var field = _a.field;
                                                            return (React.createElement(RecekTextField, __assign({ labelId: "stripes-core.publishers.guarantors.field.label.email" }, field, { autoComplete: "off", required: true, error: (_d = (_c = (_b = errors.guarantors) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.email) === null || _d === void 0 ? void 0 : _d.message })));
                                                        } })),
                                                React.createElement(Col, { xs: 2 }, guarantorFields.length > 1 && (React.createElement(Button, { buttonStyle: "danger", onClick: function () { return removeGuarantorAtIndex(index); }, style: { marginTop: "25px" } },
                                                    React.createElement(FormattedMessage, { id: "stripes-core.publishers.guarantors.button.delete" })))),
                                                React.createElement(Col, { xs: 12 },
                                                    React.createElement(Row, null,
                                                        React.createElement("h3", null, "Kontakty")), (_a = watch("guarantors.".concat(index, ".contacts"))) === null || _a === void 0 ? void 0 :
                                                    _a.map(function (contact, contactIndex) { return (React.createElement(Row, { key: contactIndex, style: { marginBottom: "10px" } },
                                                        React.createElement(Col, { xs: 4 },
                                                            React.createElement(Controller, { control: control, name: "guarantors.".concat(index, ".contacts.").concat(contactIndex, ".type"), render: function (_a) {
                                                                    var _b, _c, _d, _e, _f, _g, _h, _j;
                                                                    var field = _a.field;
                                                                    return (React.createElement(RecekSelect, __assign({ autoComplete: "off", labelId: "stripes-core.publishers.guarantors.contacts.select.label.type", error: typeof ((_e = (_d = (_c = (_b = errors.guarantors) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.contacts) === null || _d === void 0 ? void 0 : _d[contactIndex]) === null || _e === void 0 ? void 0 : _e.type) === "object"
                                                                            ? (_j = (_h = (_g = (_f = errors.guarantors) === null || _f === void 0 ? void 0 : _f[index]) === null || _g === void 0 ? void 0 : _g.contacts) === null || _h === void 0 ? void 0 : _h[contactIndex]) === null || _j === void 0 ? void 0 : _j.type.message
                                                                            : undefined }, field, { dataOptions: [
                                                                            {
                                                                                value: "",
                                                                                label: formatMessage({
                                                                                    id: "stripes-core.publishers.contacts.select.label.default",
                                                                                }),
                                                                            },
                                                                            {
                                                                                value: "EMAIL",
                                                                                label: formatMessage({
                                                                                    id: "stripes-core.publishers.guarantors.contacts.select.label.email",
                                                                                }),
                                                                            },
                                                                            {
                                                                                value: "WEB",
                                                                                label: formatMessage({
                                                                                    id: "stripes-core.publishers.guarantors.contacts.select.label.web",
                                                                                }),
                                                                            },
                                                                            {
                                                                                value: "PHONE",
                                                                                label: formatMessage({
                                                                                    id: "stripes-core.publishers.guarantors.contacts.select.label.phone",
                                                                                }),
                                                                            },
                                                                            {
                                                                                value: "DATA_BOX",
                                                                                label: formatMessage({
                                                                                    id: "stripes-core.publishers.guarantors.contacts.select.label.dataBox",
                                                                                }),
                                                                            },
                                                                        ] })));
                                                                } })),
                                                        React.createElement(Col, { xs: 4 },
                                                            React.createElement(Controller, { control: control, name: "guarantors.".concat(index, ".contacts.").concat(contactIndex, ".value"), render: function (_a) {
                                                                    var _b, _c, _d, _e, _f;
                                                                    var field = _a.field;
                                                                    return (React.createElement(RecekTextField, __assign({ autoComplete: "off", labelId: "stripes-core.publishers.contacts.field.label.contact", error: (_f = (_e = (_d = (_c = (_b = errors.guarantors) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.contacts) === null || _d === void 0 ? void 0 : _d[contactIndex]) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.message }, field)));
                                                                } })),
                                                        React.createElement(Col, { xs: 4 },
                                                            React.createElement(Controller, { control: control, name: "guarantors.".concat(index, ".contacts.").concat(contactIndex, ".info"), render: function (_a) {
                                                                    var field = _a.field;
                                                                    return (React.createElement(RecekTextField, __assign({ autoComplete: "off", labelId: "stripes-core.publishers.contacts.field.label.info" }, field)));
                                                                } })),
                                                        React.createElement(Col, { xs: 2 },
                                                            React.createElement(Button, { buttonStyle: "danger", onClick: function () {
                                                                    var currentContacts = getValues("guarantors.".concat(index, ".contacts")) || [];
                                                                    var updatedContacts = currentContacts.filter(function (_, i) { return i !== contactIndex; });
                                                                    setValue("guarantors.".concat(index, ".contacts"), updatedContacts);
                                                                }, style: { marginTop: "25px" } },
                                                                React.createElement(FormattedMessage, { id: "stripes-core.publishers.guarantors.contacts.button.delete" }))))); }),
                                                    React.createElement(Button, { type: "button", onClick: function () {
                                                            var currentContacts = getValues("guarantors.".concat(index, ".contacts")) ||
                                                                [];
                                                            setValue("guarantors.".concat(index, ".contacts"), __spreadArray(__spreadArray([], currentContacts, true), [
                                                                { type: "", value: "" },
                                                            ], false));
                                                        } },
                                                        React.createElement(FormattedMessage, { id: "stripes-core.publishers.guarantors.contacts.button.add" }))))));
                                    }),
                                    React.createElement(Button, { type: "button", onClick: function () {
                                            return appendGuarantor({
                                                id: "",
                                                firstName: "",
                                                lastName: "",
                                                email: "",
                                                contacts: [],
                                                user: {
                                                    sourceId: "",
                                                    firstName: "",
                                                    lastName: "",
                                                    email: "",
                                                    roles: [],
                                                },
                                            });
                                        }, style: { marginTop: "20px" } },
                                        React.createElement(FormattedMessage, { id: "stripes-core.publishers.guarantors.button.add" }))))),
                        watch("registrationIntent") === "ONE_OFF" && (React.createElement(Accordion, { label: React.createElement(RecekAccordionLabel, { labelId: "stripes-core.publishers.accordion.label.workSpec" }), open: accordionStatus.workSpecification, onToggle: function () {
                                return setAccordionStatus(__assign(__assign({}, accordionStatus), { workSpecification: !accordionStatus.workSpecification }));
                            } },
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 12 },
                                    React.createElement(Controller, { control: control, name: "workSpecification.title", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.workSpec.field.label.title", required: true, error: (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.title) === null || _c === void 0 ? void 0 : _c.message })));
                                        } })),
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "workSpecification.subtitle", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.workSpec.field.label.subTitle", error: (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.subtitle) === null || _c === void 0 ? void 0 : _c.message })));
                                        } }))),
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 12 },
                                    React.createElement(Controller, { control: control, name: "workSpecification.volumeNumber", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.workSpec.field.label.volumeNumber", error: (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.volumeNumber) === null || _c === void 0 ? void 0 : _c.message })));
                                        } }))),
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 12 },
                                    React.createElement(Controller, { control: control, name: "workSpecification.partTitle", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.workSpec.field.label.partName", error: (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.partTitle) === null || _c === void 0 ? void 0 : _c.message })));
                                        } }))),
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 12 },
                                    React.createElement("h3", null,
                                        React.createElement(FormattedMessage, { id: "stripes-core.publishers.workSpec.title.authors" }))),
                                React.createElement(Col, { xs: 12 }, authorFields.map(function (author, index) { return (React.createElement(AuthorityAuthorRow, { key: author.id, author: watchedAuthors === null || watchedAuthors === void 0 ? void 0 : watchedAuthors[index], linkedPersonIds: personIdsLinkedElsewhere(watchedAuthors, index), searchAuthors: searchAuthorityAuthors, onPick: function (picked) {
                                        return setValue("workSpecification.authors.".concat(index), picked, { shouldValidate: true });
                                    }, onClear: function () {
                                        return setValue("workSpecification.authors.".concat(index), unlinkedAuthor(), { shouldValidate: true });
                                    }, onRemove: function () { return removeAuthor(index); }, renderNameField: function (name, readOnly) { return (React.createElement(Controller, { control: control, name: "workSpecification.authors.".concat(index, ".").concat(name), render: function (_a) {
                                            var _b, _c, _d, _e;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { readOnly: readOnly, autoComplete: "off", labelId: "stripes-core.publishers.workSpec.field.label.authors.".concat(name), error: (_e = (_d = (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.authors) === null || _c === void 0 ? void 0 : _c[index]) === null || _d === void 0 ? void 0 : _d[name]) === null || _e === void 0 ? void 0 : _e.message })));
                                        } })); } })); }))),
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 12 },
                                    React.createElement(Button, { onClick: function () { return appendAuthor(unlinkedAuthor()); } },
                                        React.createElement(FormattedMessage, { id: "stripes-core.publishers.workSpec.button.authors.add" })))),
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "workSpecification.publicationDate", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.workSpec.datePicker.label.publicationDate", error: (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.publicationDate) === null || _c === void 0 ? void 0 : _c.message, placeholder: "DD.MM.RRRR / MM.RRRR / RRRR", required: true })));
                                        } })),
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(Controller, { control: control, name: "workSpecification.editionNumber", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.workSpec.field.label.releaseOrder", error: (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.editionNumber) === null || _c === void 0 ? void 0 : _c.message, required: true })));
                                        } }))),
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 12 },
                                    React.createElement(Controller, { control: control, name: "workSpecification.coEditionWith", render: function (_a) {
                                            var _b, _c;
                                            var field = _a.field;
                                            return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.workSpec.field.label.publishedInConjunction", error: (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.coEditionWith) === null || _c === void 0 ? void 0 : _c.message })));
                                        } }))),
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 12 },
                                    React.createElement(Controller, { control: control, name: "workSpecification.publicationForm", render: function (_a) {
                                            var _b, _c, _d;
                                            var field = _a.field;
                                            return (React.createElement(RecekSelect, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.workSpec.select.label.publicationForm", required: true, value: (_b = field.value) !== null && _b !== void 0 ? _b : "", onChange: function (e) {
                                                    return handlePublicationFormChange(e.target.value);
                                                }, error: (_d = (_c = errors.workSpecification) === null || _c === void 0 ? void 0 : _c.publicationForm) === null || _d === void 0 ? void 0 : _d.message, dataOptions: __spreadArray([
                                                    {
                                                        value: "",
                                                        label: formatMessage({
                                                            id: "stripes-core.publishers.select.label.default",
                                                        }),
                                                    }
                                                ], PUBLICATION_FORM_OPTIONS.map(function (option) { return ({
                                                    value: option.value,
                                                    label: formatMessage({ id: option.labelId }),
                                                }); }), true) })));
                                        } }))),
                            selectedPublicationForm && (React.createElement(Row, null,
                                React.createElement(Col, { xs: 12 },
                                    React.createElement(RecekSelect, { key: selectedPublicationForm, name: REFINING_SELECTS[selectedPublicationForm].name, autoComplete: "off", labelId: REFINING_SELECTS[selectedPublicationForm].labelId, required: true, value: (_b = formatsOfPublicationForm(watch("workSpecification"), selectedPublicationForm)[0]) !== null && _b !== void 0 ? _b : "", onChange: function (e) {
                                            return handleRefiningFormatChange(e.target.value);
                                        }, error: refiningFormatError(selectedPublicationForm), dataOptions: __spreadArray([
                                            {
                                                value: "",
                                                label: formatMessage({
                                                    id: "stripes-core.publishers.select.label.default",
                                                }),
                                            }
                                        ], REFINING_SELECTS[selectedPublicationForm].options.map(function (option) { return ({
                                            value: option.value,
                                            label: formatMessage({ id: option.labelId }),
                                        }); }), true) })))),
                            selectedPublicationForm === "EBOOK" && (React.createElement(Row, null,
                                React.createElement(Col, { xs: 12 },
                                    React.createElement("h3", null,
                                        React.createElement(FormattedMessage, { id: "stripes-core.publishers.workSpec.select.label.ebookFormats.other" }))),
                                React.createElement(Col, { xs: 12 }, otherFormatFields.map(function (formatField, index) { return (React.createElement(Row, { key: formatField.id },
                                    React.createElement(Col, { xs: 10 },
                                        React.createElement(Controller, { control: control, name: "workSpecification.otherFormats.".concat(index, ".format"), render: function (_a) {
                                                var _b, _c, _d, _e;
                                                var field = _a.field;
                                                return (React.createElement(RecekTextField, __assign({}, field, { autoComplete: "off", labelId: "stripes-core.publishers.workSpec.select.label.ebookFormats.otherFormat", error: (_e = (_d = (_c = (_b = errors.workSpecification) === null || _b === void 0 ? void 0 : _b.otherFormats) === null || _c === void 0 ? void 0 : _c[index]) === null || _d === void 0 ? void 0 : _d.format) === null || _e === void 0 ? void 0 : _e.message })));
                                            } })),
                                    React.createElement(Col, { xs: 2 },
                                        React.createElement(Button, { buttonStyle: "danger", onClick: function () { return removeOtherFormat(index); }, style: { marginTop: "25px" } },
                                            React.createElement(FormattedMessage, { id: "stripes-core.publishers.workSpec.button.delete" }))))); })),
                                React.createElement(Col, { xs: 12 },
                                    React.createElement(Button, { onClick: function () {
                                            return appendOtherFormat({ format: "" }, { shouldFocus: false });
                                        } },
                                        React.createElement(FormattedMessage, { id: "stripes-core.publishers.workSpec.button.ebookFormats.add" }))))))),
                        React.createElement(Accordion, { label: React.createElement(RecekAccordionLabel, { labelId: "stripes-core.publishers.accordion.label.comments" }), open: accordionStatus.comments, onToggle: function () {
                                return setAccordionStatus(__assign(__assign({}, accordionStatus), { comments: !accordionStatus.comments }));
                            } },
                            React.createElement(Controller, { control: control, name: "internalComment", render: function (_a) {
                                    var _b;
                                    var field = _a.field;
                                    return (React.createElement(RecekTextArea, __assign({ labelId: "stripes-core.publishers.comments.textArea.label.internalComment" }, field, { autoComplete: "off", error: (_b = errors.internalComment) === null || _b === void 0 ? void 0 : _b.message })));
                                } })),
                        React.createElement(Accordion, { label: React.createElement(RecekAccordionLabel, { labelId: "stripes-core.publishers.accordion.label.spam" }), open: accordionStatus.spam, onToggle: function () {
                                return setAccordionStatus(__assign(__assign({}, accordionStatus), { spam: !accordionStatus.spam }));
                            } },
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 6 },
                                    React.createElement(AltchaWidget, { ref: captchaRef, challengePath: REGISTRATION_CAPTCHA_PATH, onPayload: handleCaptchaPayload })))))))),
        React.createElement("div", { id: "OverlayContainer" }),
        showConfirmation && (React.createElement(ConfirmationModal, { open: showConfirmation, heading: formatMessage({
                id: "stripes-core.publishers.general.modal.heading.companyNumber",
            }), message: formatMessage({
                id: "stripes-core.publishers.general.modal.message.companyNumber",
            }), onConfirm: handleConfirmPopup, onCancel: function () {
                setShowConfirmation(false);
                setPendingData(null);
            }, confirmLabel: formatMessage({
                id: "stripes-core.button.save",
            }), cancelLabel: formatMessage({
                id: "stripes-core.button.cancel",
            }), buttonStyle: "primary" }))));
};
export default PublisherRegistration;
